// Move bootstrap here? We can if we separate CSS with mini-css-extract-plugin
// import 'monitoring.js' // is this meant to be on the home page only or all pages
// isotope.pkgd.min.js?
// bootstrap JS?
// The CSS needs to come just after tidy.css - but maybe we can get the JS only to load here? (TODO?)
//import 'bootstrap'
//import 'css/lowprio.sass'
// Do we need classie or isotope? Classie appears obsolete. isotope is commercial - we should avoid it or pay.
// import '@fortawesome/fontawesome-free'
// import '@fortawesome/fontawesome-free/js/all.js';
import "fontawesome.js";
import "search.js";
import "language.js";
import "ccikecookieconsent.js";
import "external-links.js";
import "equalise-cards.js";
import $ from "jquery";
import { Tab } from "bootstrap";

// Function to activate tab based on fragment identifier
const activateTabFromFragment = () => {
  const fragment = window.location.hash;

  if (!fragment || fragment.includes("/")) {
    return;
  }

  const tabLink = $(`a[href="${fragment}"]`);
  if (tabLink.length > 0) {
    tabLink.tab("show");
  }

  if (fragment.length > 0) {
    try {
      // Find the tab content element with the id corresponding to the fragment
      const tabContent = document.querySelector(fragment);
      // Check if the tab content element exists
      if (tabContent) {
        Tab.getOrCreateInstance(tabContent).show();
      }
    } catch (error) {
      console.warn("Invalid fragment selector:", fragment);
    }
  }
};

// Activate tab on page load
activateTabFromFragment();
